import { useFormContext } from 'react-hook-form';
import { Banner } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { CreditNoteFormValues } from './formMapping';

interface Props {
    isEditForm: boolean;
    defaultValues: CreditNoteFormValues;
}

export const DefaultCreditNoteWarningBanner = ({ isEditForm, defaultValues }: Props) => {
    const { watch } = useFormContext<CreditNoteFormValues>();
    const isDefault = watch('isDefault');

    // We only display the banner if change the default value to true, if it wasn't previously true or creating a new counter
    if ((!isDefault || isEditForm) && (!isDefault || !isEditForm || defaultValues?.isDefault !== false)) return null;

    return (
        <Banner
            variant="warning"
            primaryText={lt('CounterDefaultBannerTitle')}
            secondaryText={lt('CounterDefaultBannerDescription')}
        />
    );
};
